export default "__VITE_ASSET__Hg$2AJL9__";